export const UNAVAILABLE_PORTAL = `Сайт временно недоступен`

export const UNAVAILABLE_PORTAL_INFORMATION = `В данный момент проводятся технические работы, которые скоро закончатся.`

export const UNAVAILABLE_SECTION = `Раздел временно недоступен`

export const UNAVAILABLE_INFORMATION = `В данный момент проводятся технические работы, которые скоро закончатся.`
